<template>
  <Teleport to="body">
    <Transition name="fade">
      <div
        v-if="confirmState.visible"
        class="fixed inset-0 bg-black/50 flex items-center justify-center z-[60] p-4"
        @click.self="resolveConfirm(false)"
      >
        <Transition name="pop" appear>
          <div class="bg-white rounded-2xl max-w-sm w-full p-6 shadow-2xl">
            <div class="flex items-start gap-4">
              <!-- Ícone -->
              <div
                class="shrink-0 w-12 h-12 rounded-full flex items-center justify-center"
                :class="confirmState.danger ? 'bg-red-100' : ''"
                :style="confirmState.danger ? {} : { backgroundColor: companyStore.primaryColor + '20' }"
              >
                <ExclamationTriangleIcon
                  v-if="confirmState.danger"
                  class="w-6 h-6 text-red-600"
                />
                <QuestionMarkCircleIcon
                  v-else
                  class="w-6 h-6"
                  :style="{ color: companyStore.primaryColor }"
                />
              </div>

              <div class="flex-1 min-w-0">
                <h3 class="text-lg font-bold text-gray-900 mb-1">
                  {{ confirmState.title }}
                </h3>
                <p class="text-sm text-gray-600">
                  {{ confirmState.message }}
                </p>
              </div>
            </div>

            <div class="flex justify-end gap-2 mt-6">
              <button
                @click="resolveConfirm(false)"
                class="px-4 py-2 bg-white text-gray-700 border border-gray-300 rounded-lg font-medium hover:bg-gray-50 transition-colors"
              >
                {{ confirmState.cancelLabel }}
              </button>
              <button
                @click="resolveConfirm(true)"
                class="px-4 py-2 text-white rounded-lg font-medium transition-opacity hover:opacity-90"
                :class="confirmState.danger ? 'bg-red-600' : ''"
                :style="confirmState.danger ? {} : { backgroundColor: companyStore.primaryColor }"
              >
                {{ confirmState.confirmLabel }}
              </button>
            </div>
          </div>
        </Transition>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { ExclamationTriangleIcon, QuestionMarkCircleIcon } from '@heroicons/vue/24/outline'
import { useCompanyStore } from '@/stores'
import { confirmState, resolveConfirm } from '@/composables/useConfirm'

const companyStore = useCompanyStore()
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.pop-enter-active {
  transition: transform 0.2s ease, opacity 0.2s ease;
}
.pop-enter-from {
  transform: scale(0.95);
  opacity: 0;
}
</style>
